import { LeaveApplicationTemplateBase } from './LeaveApplicationTemplateBase';
import { LeaveApplicationPDFProps } from './types';

export const SingleYearLeaveApplicationPDFTemplate = (
  props: LeaveApplicationPDFProps,
) => {
  const {
    requestType,
    requestYear,
    previousYearDaysUsedForRequest = 0,
    currentYearDaysUsedForRequest = 0,
  } = props;

  // The "aferent anului X" qualifier is specific to Annual Leave's
  // carry-over-by-calendar-year balance concept - it doesn't apply to the 5
  // new leave types (a one-off Marriage/Blood Donation/... leave isn't
  // "for" a particular year the way annual leave balance is).
  if (requestType && requestType !== 'ANNUAL_LEAVE') {
    return <LeaveApplicationTemplateBase {...props} yearQualifier="" />;
  }

  const previousYear = requestYear - 1;
  const selectedYear =
    previousYearDaysUsedForRequest > 0 && currentYearDaysUsedForRequest === 0
      ? previousYear
      : requestYear;

  return (
    <LeaveApplicationTemplateBase
      {...props}
      yearQualifier={` aferent anului ${selectedYear}`}
    />
  );
};
